import { createRouter, createWebHistory } from 'vue-router'

import { store } from '@/store'

import Home from '../views/Home.vue'

import Route from '../views/Route.vue'

import UserAccount from '../views/pages/user/UserAccount.vue'
import UserRoutes from '../views/pages/user/UserRoutes.vue'
import UserSettings from '../views/pages/user/UserSettings.vue'

import Migration from '../views/Migration.vue'
import MigrationRoute from '../views/MigrationRoute.vue'

import { authUser } from '@/services/auth.service'
import { setWindowTitle } from '@/api/tools'

const routes = [
  {
    path: '/r/:id',
    name: 'Route',
    component: Route
  },
  {
    path: '/account',
    name: 'Profil',
    component: UserAccount,
    meta: { requiresAuth: true }
  },
  {
    path: '/routes',
    name: 'Ruter',
    component: UserRoutes,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Indstillinger',
    component: UserSettings,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/pages/Privacy.vue')
  },
  {
    path: '/tos',
    name: 'Brugsvilkår',
    component: () => import('../views/pages/TOS.vue')
  },
  {
    path: '/about',
    name: 'Om',
    component: () => import('../views/pages/About.vue')
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('../views/pages/FAQ.vue')
  },
  {
    path: '/migrate/:id/:uid',
    name: 'Overfør rute',
    component: Migration,
    meta: { requiresAuth: true }
  },
  {
    path: '/:id',
    name: 'Gammel rute',
    component: MigrationRoute
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})



router.beforeEach((to, from, next) => {
  setWindowTitle((to.name == 'Home' ? 'Planlæg ruten til vognturen nemt og hurtigt' : to.name as string) || 'Tripply')
  if (to.query.redirect) {
    authUser().then(user => {
      if (!user) {
        store.modal.showModal('SignIn')
      }
    })
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    authUser().then(user => {
      if (!user) {
        store.modal.showModal('SignIn')
        next({
          path: '/',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    })

  } else {
    next()
  }
})

export default router
